'use client';

import React, { memo } from 'react';
import { usePerf } from '@/contexts/PerformanceContext';
import HeroContent from './HeroContent';
import HeroPipeline from './HeroPipeline';

function HeroSection() {
  const { reducedMotion } = usePerf();

  return (
    <section
      id="hero"
      className="relative flex min-h-[100svh] flex-col overflow-hidden bg-[#0F1117] text-white"
      aria-label="Hero"
    >
      <div className="relative z-10 mx-auto flex w-full max-w-[1440px] flex-1 flex-col justify-center px-5 pb-14 pt-24 sm:px-8 lg:px-16 lg:pb-16 lg:pt-28">
        <HeroContent
          reducedMotion={reducedMotion}
          visual={<HeroPipeline reducedMotion={reducedMotion} />}
        />
      </div>
    </section>
  );
}

export default memo(HeroSection);
